import { Route, Routes, } from "react-router-dom";
import Home from "../pages/home/Home";
import AboutUs from "../pages/aboutus/AboutUs";
import ContactUs from "../pages/contactus/ContactUs";
import HomeHeader from "../components/layout/home/header/HomeHeader";
import HomeFooter from "../components/layout/home/footer/HomeFooter";
import SpeakerRequest from "../pages/speaker_request/SpeakerRequest";
import Book from "../pages/book/book";
import DonationSucess from "../pages/donation/donationsucess";
import Letter from "../pages/donation/letter";
import PrivacyPolicy from "../pages/PrivacyPolicy/privacypolicy";
import TermOfService from "../pages/Termofconditions/termsofservice";
import Adminpayment from "../pages/donation/adminpayment";
import Information from "../pages/donation/information";
import Churchesabout from "../pages/aboutus/churches";
// import HBCU from "../pages/hbcu/hbcu";
import Jointheprolifemovement from "../pages/college/collegeintern";
import  ForgottenWomen from "../pages/home/forgottenwomen"

const LoginRoutes = () => {

  return (
    <>
      <HomeHeader />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/book" element={<Book />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/speaker-request" element={<SpeakerRequest />} />
        <Route path="/success" element={<DonationSucess/>}/>
        <Route path="/letter" element={<Letter/>}/>
        <Route path="/privacy" element={<PrivacyPolicy/>}/>
        <Route path="/termofservice" element={<TermOfService/>}/>
        <Route path="/donate-to-us" element={<Adminpayment/>}/>
        <Route path="/information" element={<Information/>}/>
        <Route path="/church" element={<Churchesabout/>}/>
        {/* <Route path="/hbcu" element={<HBCU/>}/> */}
        <Route path="/join-the-pro-life-movement" element={<Jointheprolifemovement/>}/>
        <Route path="/forgottenwomen" element={<ForgottenWomen/>}/>
      </Routes>
      <HomeFooter />
    </>
  );
};

export default LoginRoutes;
